import { Component, Input, EventEmitter, Output, OnInit, ViewChildren, ViewContainerRef, QueryList } from '@angular/core';

import { HisAuthService } from 'hisng';

import { DYNAMIC_FIELDSET_ANCHOR } from 'app/fs/res/common/model/dynamic-content/constants';
import { ProviderManager } from 'app/fs/res/common/utils/provider-manager';

import { Patent } from 'app/fs/res/patent/model/patent/patent';

@Component( {
    selector: 'res-patent-research-tab',
    templateUrl: './patent-research-tab.component.html',
    providers: [ProviderManager.getComponentProvider(PatentResearchTabComponent)],
} )
export class PatentResearchTabComponent implements OnInit {
    @Input() patent: Patent;
    @Output() patentChange: EventEmitter<Patent> = new EventEmitter<Patent>();
    @ViewChildren( DYNAMIC_FIELDSET_ANCHOR, { read: ViewContainerRef } )
        fieldsetViewContainerList: QueryList<ViewContainerRef>;

    constructor( public auth: HisAuthService ) { }

    /* Component ngOnInit() */
    ngOnInit() {
        if ( !this.patent.projects ) {
            this.patent.projects = [];
        }
    }
}
